import { render, staticRenderFns } from "./SettingsHomeInfo.vue?vue&type=template&id=4a6f2b8a&scoped=true&"
import script from "./SettingsHomeInfo.vue?vue&type=script&lang=js&"
export * from "./SettingsHomeInfo.vue?vue&type=script&lang=js&"
import style1 from "./SettingsHomeInfo.vue?vue&type=style&index=1&id=4a6f2b8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f2b8a",
  null
  
)

export default component.exports